import type { Nullable } from "../../typescript"

export default function hasLengthOne<T>(list: Nullable<Array<T>>): boolean {
  return list?.length === 1
}